import {
  GET_RECEIPT_FAIL,
  GET_RECEIPT_REGUEST,
  GET_RECEIPT_SUCCESS,
} from "src/constants/types";

export const receiptReducers = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_RECEIPT_REGUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        receipt_operation: payload,
      };
    case GET_RECEIPT_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
